export default "__VITE_ASSET__D1ydcjX___"